<template>
  <tr :id="'mediaInsertionInvoiceListInfo' + pInvoice.id" ref="bsInvoiceListInfo">
    <td v-if="actionsColumnsVisible" class="text-nowrap">
      <span data-toggle="tooltip-inline" data-placement="top"
            :title="pDictionary['dictionary.actions.update']">
        <a :href="updateInvoiceUrl"
         :class="[{'disabled': !pInvoice.allowedTo['UPDATE_INVOICE']}, 'btn btn-default btn-sm ajax-support show-waiting']"
           data-ajax-support-csv="#ajaxModuleForm,#popoverInvoiceListInfo"><i class="fa-light fa-pencil"></i></a>
      </span>
      <span data-toggle="tooltip-inline" data-placement="top"
            :title="pDictionary['dictionary.actions.delete']">
        <a :href="deleteInvoiceUrl"
         :class="[{'disabled': !pInvoice.allowedTo['DELETE_INVOICE']}, 'btn btn-default btn-sm bs3-margin-left3 ajax-support show-waiting']"
           data-ajax-support-csv="#ajaxModuleForm,#popoverInvoiceListInfo"><i class="fa-light fa-trash-alt"></i></a>
      </span>
      <span data-toggle="tooltip-inline" data-placement="top"
            :title="pDictionary['dictionary.actions.merge']">
        <a :href="mergeInvoiceUrl"
           :class="[{'disabled': !pInvoice.allowedTo['MERGE_INVOICE']}, 'btn btn-default btn-sm bs3-margin-left3 ajax-support show-waiting']"
           data-ajax-support-csv="#ajaxModuleForm,#popoverInvoiceListInfo"><i class="fa-light fa-code-merge"></i></a>
      </span>
      <span data-toggle="tooltip-inline" data-placement="top"
            :title="pDictionary['dictionary.actions.split']">
        <a :href="splitInvoiceUrl"
           :class="[{'disabled': !pInvoice.allowedTo['SPLIT_INVOICE']}, 'btn btn-default btn-sm bs3-margin-left3 ajax-support show-waiting']"
           data-ajax-support-csv="#ajaxModuleForm,#popoverInvoiceListInfo"><i class="fa-light fa-code-branch"></i></a>
      </span>
      <a :href="unexpectedInvoiceUrl"
         :class="[{'disabled': !pInvoice.allowedTo['UPDATE_INVOICE_EXPECTED']}, 'btn btn-default btn-sm bs3-margin-left3 ajax-support show-waiting']"
         data-ajax-support-csv="#ajaxModuleForm,#popoverInvoiceListInfo"><i class="fa-light fa-file-times"></i></a>
    </td>
    <td class="minWidthCell text-right">
      {{ pInvoice.periodStartDateText }}
    </td>
    <td class="minWidthCell text-center">
      -
    </td>
    <td class="minWidthCell text-left">
      {{ pInvoice.periodEndDateText }}
    </td>
    <td class="text-center">
      <div v-if="statusDropdownVisible" class="btn-group ignore-width">
          <button type="button" class="btn btn-xs btn-default dropdown-toggle" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false" :style="statusStyle">
            <span>{{ i18nRefName(pInvoice.statusRef, pLanguage) }}</span> <span class="caret"></span>
          </button>
        <ul class="dropdown-menu" :data-dropdown-menu-parent-container="'#mediaInsertionInvoiceListInfo' + pInvoice.id"
            :data-ajax-options-url="pUrls['getStatusDropdownOptions']"
            :data-option-url-prefix="statusOptionsUrl">
        </ul>
      </div>
      <span v-else>{{ pInvoice.statusRef.name }}</span>
    </td>
    <td class="minWidthCell text-center">
      {{ pInvoice.dateText | emptyToDash }}
    </td>
    <td>
      {{ pInvoice.reference | emptyToDash }}
    </td>
    <td :class="['text-right text-nowrap text-muted']">
      <div>{{ pInvoice.plannedTotalVendorCostText | money(pCurrencies, pCurrencyRef.id) | emptyToDash }}</div>
    </td>
    <td :class="['text-right text-nowrap text-muted']">
        <div>{{ pInvoice.actualTotalVendorCostText | money(pCurrencies, pCurrencyRef.id) | emptyToDash }}</div>
    </td>
    <td class="text-right text-nowrap">
      {{ pInvoice.invoicedTotalVendorCostText | money(pCurrencies, pCurrencyRef.id) | emptyToDash }}
    </td>
    <td v-if="pCommissionEnabled" class="text-right text-nowrap">
      {{ pInvoice.invoicedCommissionCostText | money(pCurrencies, pCurrencyRef.id) | emptyToDash }}
    </td>
  </tr>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormatMixin from "@/mixins/format-mixin";
import refHelpers from "@/helpers/ref-helpers";

export default {
  name: "MediaInsertionInvoiceListInfoSectionTableRow",
  components: {},
  mixins: [BaseMixin, FormatMixin],
  props: {
    pCurrencies: Array,
    pLanguage: String,
    pDictionary: Object,
    pUrls: Object,
    pSrc: String,
    pSrcId: String,
    pCurrencyRef: Object,
    pInvoice: Object,
    pCommissionEnabled: Boolean,
    pFormDisplay: Boolean
  },
  data: function () {
    return {}
  },
  methods: {},
  computed: {
    actionsColumnsVisible: function() {
      return !this.pFormDisplay;
    },
    statusDropdownVisible: function() {
      return !this.pFormDisplay && this.pInvoice.allowedTo['UPDATE_INVOICE'];
    },
    statusOptionsUrl: function() {
      return this.pUrls['bulkInvoice'] +
             '?bulkCmdDataForm.ids=' + this.pInvoice.id +
             '&bulkCmdDataForm.actionName=InvoiceStatus&bulkCmdDataForm.input=true' +
             '&src=' + this.pSrc + '&srcId=' + this.pSrcId;
    },
    statusStyle: function () {
      return {
        'background-color': '#' + this.pInvoice.statusRef.params.displayColor,
        'border-color': '#' + this.pInvoice.statusRef.params.displayColor,
        'color': '#' + this.pInvoice.statusRef.params.displayTextColor
      }
    },
    updateInvoiceUrl: function() {
      return this.pUrls['updateInvoice'] + '?dataId=' + this.pInvoice.id + '&src=' + this.pSrc + '&srcId=' + this.pSrcId;
    },
    deleteInvoiceUrl: function() {
      return this.pUrls['confirmDeleteInvoice'] + '?dataId=' + this.pInvoice.id + '&src=' + this.pSrc + '&srcId=' + this.pSrcId
    },
    mergeInvoiceUrl: function() {
      return this.pUrls['bulkInvoice'] +
        '?bulkCmdDataForm.ids=' + this.pInvoice.id +
        '&bulkCmdDataForm.actionName=InvoiceMerge' +
        '&src=' + this.pSrc + '&srcId=' + this.pSrcId;
    },
    splitInvoiceUrl: function() {
      return this.pUrls['bulkInvoice'] +
             '?bulkCmdDataForm.ids=' + this.pInvoice.id +
             '&bulkCmdDataForm.actionName=InvoiceSplit' +
             '&src=' + this.pSrc + '&srcId=' + this.pSrcId;
    },
    unexpectedInvoiceUrl: function() {
      return this.pUrls['bulkInvoice'] +
             '?bulkCmdDataForm.ids=' + this.pInvoice.id +
             '&bulkCmdDataForm.actionName=InvoiceUnexpected' +
             '&src=' + this.pSrc + '&srcId=' + this.pSrcId;
    }
  }
}
</script>

<style scoped>

</style>